<template>
  <div>
    <template>
      <v-card>
        <v-card-title>
          <span class='headline fontcolor'>{{ formTitle }}</span>
        </v-card-title>
        <v-card class='pl-7 pr-6 pt-5 pb-5'>
          <v-form ref='form' v-model='valid' lazy-validation>
            <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.postalCode'
                  :rules='postalCodeRules'
                  :maxlength='maxLength'
                  hint='Please enter a unique 5-digit Postal Code.'
                  label='Postal Code*'
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model='editedItem.status'
                  :items='statusItems'
                  label='Status*'
                  :rules='statusRules'
                  item-text='statusText'
                  item-value='statusVal'
                ></v-select>
              </v-col>
            </v-row>
             <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.createdBy'
                  label='Created By'
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
             <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.createdDate'
                  label='Created Date'
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
             <v-row>
              <v-col v-if="editedItem.createdDate !== editedItem.modifiedDate">
                <v-text-field
                  v-model='editedItem.modifiedBy'
                  disabled
                  label='Modified By'
                ></v-text-field>
              </v-col>
            </v-row>
             <v-row>
              <v-col v-if="editedItem.createdDate !== editedItem.modifiedDate">
                <v-text-field
                  v-model='editedItem.modifiedDate'
                  disabled
                  label='Modified Date*'
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions>
              <small color='primary'>*indicates required fields</small>
              <v-spacer></v-spacer>
              <v-btn outlined dark color='red' @click='closeDialog'>
                <v-icon dark>mdi-close</v-icon>Cancel
              </v-btn>
              <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
                <v-icon dark>mdi-check</v-icon>Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-card>
    </template>
 </div>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  data: () => ({
    valid: false,
    maxLength: 5,
    editedIndex: -1,
    selectedPostalCode: {},
    formTitle: CONSTANTS.EDIT_POSTAL_CODE,
    editedItem: {
      postalCode: '',
      statusText: '',
      status: null,
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: ''
    },
    defaultForm: {
      postalCode: '',
      status: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: ''
    },
    btnLoader: false,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    postalCodeRules: [
      v => !!v || 'Postal Code is required.',
      v =>
        /^[0-9]+$/.test(v) ||
        'Invalid input. Only characters (A-Z, a-z), period, space, underscore, copyright, registered, trademark is allowed!'
    ],
    statusRules: [v => !!v || 'Status is required.']
  }),
  props: {
    userId: {
      type: Number,
      required: true
    },
    postalCode: {
      type: Object
    },
    selectedEditedIndex: {
      type: Number,
      required: true
    }
  },
  mounted () {
    this.selectedPostalCode = this.postalCode
    this.editItem(this.selectedPostalCode)
  },
  computed: {
  },
  methods: {
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultForm)
      this.editedIndex = -1
      this.btnLoader = false
      this.$refs.form.resetValidation()
      this.dialog = false
      this.$emit('resetEditDialog', this.dialog)
    },
    editItem (postalCode) {
      this.editedIndex = this.selectedEditedIndex
      this.editedItem = Object.assign({}, postalCode)
      this.dialog = true
      this.$emit('resetDialog', this.dialog)
    },
    save () {
      if (this.$refs.form.validate()) {
        this.btnLoader = true
        Object.assign(this.editedItem)
        let editPostalCodeData = this.editedItem
        let editedData = {
          'postalCode': editPostalCodeData.postalCode,
          'status': editPostalCodeData.status,
          'userId': this.userId,
          'id': editPostalCodeData.id
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('PostalCodeModule/editPostalCodeItem', {
            resolve,
            reject,
            editedData
          })
        })
          .then(responseData => {
            this.$globalStates.notification.text = responseData.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'green'
            this.closeDialog()
          })
          .catch(response => {
            this.$globalStates.notification.text = response.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'red'
          })
      }
    }
  }
}
</script>
